module.exports = __webpack_public_path__ + "img/news_banner_01.48530812.png";